export const PATHS = {
    dRepDirectory: '/dRep-directory',
    governanceActions: '/governance-actions'
};
